import { render, staticRenderFns } from "./RipaConfirmDialog.vue?vue&type=template&id=66c731f4"
import script from "./RipaConfirmDialog.vue?vue&type=script&lang=js"
export * from "./RipaConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports